export const educationData = [
    {
        id: 1,
        institution: 'TATA D.A.V. SCHOOL, SIJUA',
        course: '10th',
        startYear: '2016',
        endYear: '2017',
        
    },
    {
        id: 2,
        institution: 'TATA D.A.V. SCHOOL, SIJUA',
        course: '12th',
        startYear: '2018',
        endYear: '2019',
        
    },
    {
        id: 3,
        institution: 'Lovely Professional University',
        course: 'B.tech (CSE)',
        startYear: '2019',
        endYear: '2023'

    },
]